var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"error-fade"}},[(_vm.errors.length)?_c('div',{staticClass:"text-left"},[_c('span',{staticClass:"p-error"},[_vm._v(_vm._s(_vm.errors[0]))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }